
const Loader = () => {
  return (
    <div className="loader">
      <div className="loading-dots">
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
      </div>
    </div>
  );
};

export default Loader;
